










import { Component, Mixins } from 'vue-property-decorator';
import AccountsTable from '@/components/accounts/AccountsTable.vue';
import Mixin from '@/mixins/base';

@Component({
  mixins: [Mixin],
  components: {
    'accounts-table': AccountsTable
  }
})
export default class LocationAccounts extends Mixins(Mixin) {
  get locationId(): number {
    return Number(this.$route.params.locationId);
  }
}
